class ChatUI {
    constructor(chatApp) {
        this.chatApp = chatApp;
    }

    // Function to render the contacts list UI
    renderContactsList() {
        const membersWrapper = document.querySelector('.contacts-wrapper-members');
        const groupsWrapper = document.querySelector('.contacts-wrapper-groups');
        // Add Groups Section
        // const groupsTitle = document.createElement('div');
        // groupsTitle.classList.add('section-title');
        // groupsTitle.textContent = 'Groups';
        // contactsWrapper.appendChild(groupsTitle);

        // Add groups
        for (let group of this.chatApp.groupsList) {
            const groupPhoto = document.createElement('div');
            groupPhoto.classList.add('group-photo');
            groupPhoto.style.backgroundImage = `url(${group.photoUrl})`;

            const groupName = document.createElement('div');
            groupName.classList.add('contact-name');
            groupName.innerText = group.name;

            const groupContainerWrapperDiv = document.createElement('div');
            groupContainerWrapperDiv.classList.add('contact-item-wrapper');

            const groupContainerDiv = document.createElement('div');
            groupContainerDiv.classList.add('contact-item');
            groupContainerDiv.setAttribute('data-group-id', group.id);

            groupContainerDiv.appendChild(groupPhoto);
            groupContainerDiv.appendChild(groupName);

            groupContainerWrapperDiv.appendChild(groupContainerDiv);

            groupsWrapper.appendChild(groupContainerWrapperDiv);
        }

        // Display contacts
        for (let contact of this.chatApp.contactsList) {
            const contactPhoto = document.createElement('img');
            contactPhoto.classList.add('contact-photo');
            contactPhoto.src = contact.photoUrl;

            const usernameDiv = document.createElement('div');
            usernameDiv.classList.add('contact-name');
            usernameDiv.innerText = contact.name;

            const statusIndicator = document.createElement('div');
            statusIndicator.classList.add('status-indicator');
            statusIndicator.id = `status-${contact.id}`;
            
            const contactContainerWrapperDiv = document.createElement('div');
            contactContainerWrapperDiv.classList.add('contact-item-wrapper');

            const contactContainerDiv = document.createElement('div');
            contactContainerDiv.classList.add('contact-item');
            contactContainerDiv.appendChild(contactPhoto);
            contactContainerDiv.appendChild(usernameDiv);
            contactContainerDiv.appendChild(statusIndicator);

            contactContainerWrapperDiv.appendChild(contactContainerDiv);
            membersWrapper.appendChild(contactContainerWrapperDiv);
        }
    }

    // Function to initialize UI event listeners
    initializeUIEvents() {
        const contactsListElement = document.querySelector('.contacts');
        const toggleBtn = document.querySelectorAll('.js--toggle-chat');
        
        toggleBtn.forEach(btn => {
            btn.addEventListener('click', () => {
                contactsListElement.style.display = contactsListElement.style.display == 'none' ? 'block' : 'none';

                const existingWindows = document.querySelectorAll('.chat-window');
                existingWindows.forEach(window => {
                    window.remove();
                });
                // toggleBtn.textContent = contactsListElement.classList.contains('collapsed') ? '+' : '−';
            });
        });

        const chatTabs = document.querySelectorAll('.contacts-header-tab-btn');
        chatTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const activeTab = document.querySelector('.contacts-header-tab-btn.active');
                const selectedTab = tab.getAttribute('data-tab');
                console.log(selectedTab);
                if ( selectedTab == 'members' ) {
                    document.querySelector('.contacts-wrapper-members').style.display = 'block';
                    document.querySelector('.contacts-wrapper-groups').style.display = 'none';
                } else {
                    document.querySelector('.contacts-wrapper-members').style.display = 'none';
                    document.querySelector('.contacts-wrapper-groups').style.display = 'block';
                }

                if (activeTab) {
                    activeTab.classList.remove('active');
                }
                tab.classList.add('active');
            });
        });
    }
}

export default ChatUI; 